var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSidebar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9499 8.5H19.0449C19.9949 8.5 20.4949 8 20.4949 7.05V1H11.4949V7.05C11.4999 8 11.9999 8.5 12.9499 8.5Z",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1H21",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L16 10V8.5",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11L16 10",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08567 17.6567C3.68135 17.6567 4.16426 17.1738 4.16426 16.5781C4.16426 15.9824 3.68135 15.4995 3.08567 15.4995C2.48998 15.4995 2.00708 15.9824 2.00708 16.5781C2.00708 17.1738 2.48998 17.6567 3.08567 17.6567Z",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17133 20.6601C5.08791 19.7961 4.40262 19.1167 3.53855 19.0393C3.2406 19.0095 2.93669 19.0095 2.63278 19.0393C1.76872 19.1227 1.08343 19.7961 1 20.6601",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4487 17.6567C9.04439 17.6567 9.52729 17.1738 9.52729 16.5781C9.52729 15.9824 9.04439 15.4995 8.4487 15.4995C7.85302 15.4995 7.37012 15.9824 7.37012 16.5781C7.37012 17.1738 7.85302 17.6567 8.4487 17.6567Z",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5346 20.6601C10.4512 19.7961 9.7659 19.1167 8.90184 19.0393C8.60388 19.0095 8.29997 19.0095 7.99606 19.0393C7.132 19.1227 6.44671 19.7961 6.36328 20.6601",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.812 17.6567C14.4077 17.6567 14.8906 17.1738 14.8906 16.5781C14.8906 15.9824 14.4077 15.4995 13.812 15.4995C13.2163 15.4995 12.7334 15.9824 12.7334 16.5781C12.7334 17.1738 13.2163 17.6567 13.812 17.6567Z",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8977 20.6601C15.8142 19.7961 15.1289 19.1167 14.2649 19.0393C13.9669 19.0095 13.663 19.0095 13.3591 19.0393C12.495 19.1227 11.8097 19.7961 11.7263 20.6601",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9143 17.5472C19.51 17.5472 19.9929 17.0643 19.9929 16.4686C19.9929 15.8729 19.51 15.39 18.9143 15.39C18.3186 15.39 17.8357 15.8729 17.8357 16.4686C17.8357 17.0643 18.3186 17.5472 18.9143 17.5472Z",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 20.5506C20.9165 19.6865 20.2312 19.0072 19.3672 18.9297C19.0692 18.8999 18.7653 18.8999 18.4614 18.9297C17.5973 19.0131 16.912 19.6865 16.8286 20.5506",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49994 5.62C6.49958 5.62 7.30994 4.80963 7.30994 3.81C7.30994 2.81036 6.49958 2 5.49994 2C4.50031 2 3.68994 2.81036 3.68994 3.81C3.68994 4.80963 4.50031 5.62 5.49994 5.62Z",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.6601C8.86 9.21009 7.71 8.07009 6.26 7.94009C5.76 7.89009 5.25 7.89009 4.74 7.94009C3.29 8.08009 2.14 9.21009 2 10.6601",
    stroke: "#23262F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebar3);
export default __webpack_public_path__ + "static/media/Icon-sidebar-3.a16f710658a71b4a18dfcc4e6a1ac60a.svg";
export { ForwardRef as ReactComponent };